<template>
  <el-dialog
    id="teamModal"
    :visible.sync="showLocal"
    :width="dialogWidth"
    center
    @close="discard"
  >
    <el-form
      ref="teamForm"
      :model="teamForm"
      :rules="rules"
    >
      <el-form-item
        prop="name"
        :error="error.name"
      >
        <div class="title">
          {{ $t('oa.team.teamName') }}
        </div>
        <div class="description">
          {{ $t('oa.team.youCanEditTeamLater') }}
        </div>
        <el-input
          v-model="teamForm.name"
          class="teamNameInput"
          :placeholder="$t('oa.team.teamName')"
        />
      </el-form-item>

      <!--<el-form-item
        prop="leader_email"
        :error="error.leader_email"
      >
        <div class="title">
          Leader email
        </div>
        <div class="description">
          Add multiple email addresses by pasting emails or separating each email by commas
        </div>
        <el-input
          v-model="teamForm.leader_email"
          type="textarea"
          :autosize="{minRows: 4}"
          placeholder="Email address 1, Email address 2, ..."
        />
      </el-form-item>-->
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button
        round
        @click="discard"
      >
        {{ $t('common.discard') }}
      </el-button>
      <el-button
        type="primary"
        round
        @click="createTeam"
      >
        {{ $t('common.add') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import api from '@/api';
import dialog from '@/mixins/dialog';

export default {
  mixins: [dialog],

  data() {
    return {
      teamForm: {
        name: '',
        leader_email: '',
      },
      rules: {
        name: [
          { required: true, message: this.$t('oa.team.requiredTeamName'), trigger: 'blur' },
        ],
        leader_email: [
          { required: true, message: this.$t('oa.team.inputAtLeastOneLeader'), trigger: 'blur' },
        ],
      },
      error: {
        name: '',
        leader_email: '',
      },
    };
  },

  methods: {
    async createTeam() {
      this.error = {
        name: '',
        leader_email: '',
      };

      this.$refs.teamForm.validate(async (valid) => {
        if (valid) {
          this.$confirm(this.$t('oa.team.confirmCreateTeam'), '', {
            confirmButtonText: this.$t('common.ok'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning',
          }).then(async () => {
            const data = {
              name: this.teamForm.name,
            };
            // data.member_list = this.teamForm.leader_email
            //   .trim()
            //   .replace(' ', '')
            //   .replace(/\n/g, ',')
            //   .split(',')
            //   .filter((el) => el !== '')
            //   .map((email) => ({
            //     role_type: 'leader',
            //     email,
            //   }));

            try {
              const response = await api.OASetupMember(data);
              const team = response.data;
              this.$emit('newTeam', team);
              this.showLocal = false;
              this.$message.success(this.$t('oa.team.teamCreated'));
              this.$refs.teamForm.resetFields();
              this.$router.push({ name: 'teamDetail', params: { id: response.data.uuid } });
            } catch (err) {
              console.log(err);
              if (err.field) {
                this.formatAPIError(err.field);

                // // Special case of this API for error structured like:
                // // {"field":{"member_list":[{},{"email":["Enter a valid email address."]}]}}
                // // Display an error alert of the first message
                // if (err.field.member_list) {
                //   const [errObj] = err.field.member_list.filter(
                //     (el) => Object.entries(el).length > 0,
                //   );
                //   if (errObj) {
                //     const key = Object.keys(errObj)[0];
                //     this.$message.error(errObj[key][0]);
                //   }
                // }
              } else if (err.msg) {
                this.$message.error(err.msg);
              }
            }
          }).catch((err) => {});
        }
      });
    },

    formatAPIError(data) {
      Object.keys(data).forEach((key) => {
        if (data[key].length === 1) {
          [this.error[key]] = data[key];
        } else if (data[key].length > 1) {
          this.error[key] = '';
          data[key].forEach((err) => {
            if (this.error[key] === '') {
              this.error[key] = `- ${err}\n`;
            } else {
              this.error[key] += `- ${err}\n`;
            }
          });
        }
      });
    },

    discard() {
      this.$refs.teamForm.resetFields();
      this.showLocal = false;
    },
  },
};
</script>

<style lang="scss">
#teamModal {
  .el-dialog {
    min-width: 320px;

    .el-dialog__body {
      padding: 0 25px 10px 25px;

      .el-form {
        .el-form-item__content {
          line-height: 25px;

          .title {
            font-weight: bold;
          }

          .description {
            word-break: break-word;
            line-height: 20px;
            margin-bottom: 8px;
          }

          input,
          textarea {
            border-radius: 10px;
          }

          .teamNameInput {
            input {
              border-radius: 0;
              border-top: 0;
              border-left: 0;
              border-right: 0;
            }
          }

          .el-form-item__error {
            white-space: pre-line;
            padding-top: 0;
            line-height: 16px;
            position: relative;
            top: -10px;
          }
        }
      }
    }

    .el-dialog__footer {
      width: 100%;
      display: flex;
      justify-content: center;

      .dialog-footer {
        display: flex;
        width: 100%;
        max-width: 400px;
        justify-content: space-around;
      }

      .el-button {
        width: 50%;
        max-width: 170px;
        margin: 0 2px;
        padding: 12px 0;
      }
    }
  }
}
</style>
